/* IMPORT */
import { SYMBOL_OBSERVABLE } from '../symbols.js';
import { isFunction } from '../utils.js';
/* MAIN */
const isObservable = (value) => {
    return isFunction(value) && (SYMBOL_OBSERVABLE in value);
};
/* EXPORT */
export default isObservable;
